module.exports = __webpack_public_path__ + "static/img/league2.048b322b.png";